import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const SavesContext = createContext(null);

export function SavesProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState(new Set());

  const refresh = useCallback(async () => {
    if (!user) { setIds(new Set()); return; }
    try {
      const { data } = await api.get("/saves/ids");
      setIds(new Set(data));
    } catch {}
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const isSaved = (id) => ids.has(id);

  const toggle = async (id) => {
    if (!user) return { needLogin: true };
    const next = new Set(ids);
    if (next.has(id)) {
      next.delete(id); setIds(next);
      try { await api.delete(`/saves/${id}`); } catch { setIds(ids); }
      return { saved: false };
    }
    next.add(id); setIds(next);
    try { await api.post(`/saves/${id}`); } catch { setIds(ids); }
    return { saved: true };
  };

  return (
    <SavesContext.Provider value={{ isSaved, toggle, refresh, count: ids.size }}>
      {children}
    </SavesContext.Provider>
  );
}

export const useSaves = () => useContext(SavesContext) || { isSaved: () => false, toggle: async () => ({}), refresh: () => {}, count: 0 };
